export async function asyncTry<T>(
  handler: ErrorHandler,
  perform: AsyncFunction<T>,
  ...args: unknown[]
): Promise<T | void> {
  try {
    return await perform(...args);
  } catch (error) {
    return handler(error);
  }
}
